<ms-my-bets-pair-game-scoreboard [vm]="vm">
    <ms-my-bets-scoreboard-players-pair players [vm]="vm"></ms-my-bets-scoreboard-players-pair>
    <div class="mybets-scoreboard_stats" stats></div>
</ms-my-bets-pair-game-scoreboard>
